import {ChangeDetectionStrategy, Component, Input, OnInit, Optional} from '@angular/core';
import {NbDialogRef} from '@nebular/theme';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {Unsubscribable} from '@core/interfaces/unsubscribable';
import {GeneralOption} from '@core/interfaces/system/system-common';

@Component({
    selector: 'ngx-report-filter-dialog',
    templateUrl: './report-filter-dialog.component.html',
    styleUrls: ['./report-filter-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportFilterDialogComponent extends Unsubscribable implements OnInit {
    @Input() options$: Observable<GeneralOption[]>;

    options: {value: string; label: string}[];

    selectControl: FormControl = new FormControl([]);

    constructor(@Optional() private dialogRef: NbDialogRef<ReportFilterDialogComponent>) {
        super();
    }

    ngOnInit() {
        this.options$.pipe(takeUntil(this.unsubscribe$)).subscribe((_options) => (this.options = _options));
    }

    confirm() {
        this.dialogRef.close({action: 'confirm', data: [...this.selectControl.value]});
    }

    cancel() {
        this.dialogRef.close({action: 'cancel'});
    }
}
